<template>
  <div class="p-post-question">
    <CommonHeader>
      {{ title }}
      <template slot="left">
        <a v-if="step === 1" @click.prevent="cancel">取消</a>
        <svg
          v-else
          class="m-style-svg m-svg-def"
          @click="preStep"
        >
          <use xlink:href="#icon-back" />
        </svg>
      </template>
      <template slot="right">
        <a
          v-if="step !== 2"
          :class="{ disabled }"
          class="m-send-btn"
          @click.prevent="nextStep"
        >
          下一步
        </a>
        <span
          v-if="step === 2 && false"
          class="m-send-btn"
          @click="beforePost"
        >
          发布
        </span>
      </template>
    </CommonHeader>

    <TransitionGroup
      :enter-active-class="animated.enterClass"
      :leave-active-class="animated.leaveClass"
      tag="main"
      class="m-box-model m-flex-grow1 m-flex-shrink1 p-post-question-main"
    >
      <div
        v-show="step === 1"
        key="step1"
        class="content-main first-content"
      >
        <div class="m-pos-f m-box-model m-flex-grow1 m-flex-shrink1 m-main ">
          <div class="m-box m-lim-width question-title">
            <input
              ref="title"
              v-model="question.title"
              :maxlength="50"
              :warnlength="30"
              placeholder="输入标题，50字以内"
            >
          </div>

          <div class="m-box m-lim-width  content-wrap">
            <!-- <div class="textarea-shadow">{{ content }}</div> 用于撑起文本框自适应高度 -->
            <textarea
              v-model="question.body"
              placeholder="问题描述"
              :maxlength="5000"
              rows="25"
            />
          </div>
        </div>
        <div class="upload-img">
          <ImageList v-model="images" />
        </div>
      </div>
      <div
        v-show="step === 2"
        key="step2"
        class="m-pos-f m-box-model m-flex-grow1 m-flex-shrink1 m-main second-content"
      >
        <section class="form-select-item" @click="selectTopic">
          <label><span class="required-dot">*</span>选择栏目</label>
          <div class="input-wrap">
            <span class="placeholder">{{ topic && topic.name }}</span>
            <svg class="m-style-svg m-svg-def m-entry-append">
              <use xlink:href="#icon-arrow-right" />
            </svg>
          </div>
        </section>
        <FormTagsBreakLine
          v-model="tags"
          :required="true"
          class="select-tags"
          :label="$t('tags.select')"
          :placeholder="$t('tags.select')"
        />
        <div
          class="m-box-with-wrap m-box m-aln-center m-lim-width m-post-news-row m-main m-bb1"
        >
          <span class="m-post-news-row-label">{{
            $t("release.upload_attachment")
          }}</span>
          <input
            v-if="inputShow"
            ref="imagefile"
            type="file"
            class="m-rfile"
            @change="onBannerChange"
          >
          <div
            class="m-flex-grow1 m-flex-shrink1 m-text-r"
            @click="uploadAttachments"
          >
            <div class="m-box m-justify-end placeholder">
              <button class="upload-button">
                {{ $t("release.upload_attachment") }}
              </button>
            </div>
          </div>
          <div
            v-for="attachment in attachments"
            :key="attachment.id"
            class="attachment-with-box"
          >
            <div
              class="attachments_content m-box"
              @click="$download(attachment, 'show')"
            >
              <attachment-type :name="attachment.file.name || attachment.file.origin_filename" />
              <span class="attachments_name">{{ attachment.file.name|| attachment.file.origin_filename }}</span>
              <img
                src="@/images/delete.png"
                @click.stop="deleteAttachments(attachment)"
              >
            </div>
          </div>
        </div>
        <span class="submit" @click.prevent.stop="beforePost">{{ $t('release.name') }}</span>
      </div>
    </TransitionGroup>
    <ChooseTopics ref="chooseTopics" @change="onTopicChange" />
  </div>
</template>

<script>
  import _ from 'lodash'
  import { mapGetters } from 'vuex'
  import sendImage from '@/util/SendImage.js'
  import * as api from '@/api/question/questions'
  import ImageList from '@/page/post/components/ImageListWithModel'
  import ChooseTopics from '@/page/post/components/ChooseTopics'
  import AttachmentType from '@/components/common/AttachmentType.vue'

  export default {
    name: 'QuestionEdit',
    components: { ImageList, ChooseTopics, AttachmentType },
    data () {
      return {
        step: 1,
        loading: false,
        inputShow: true,
        topic: {},
        animated: {},
        question: {
          title: '',
          body: '',
          anonymity: 0,
        },

        tags: [],
        images: [],
        topics: [],
        attachments: [],
      }
    },
    computed: {
      ...mapGetters(['compose']),
      allowAnonymious () {
        return this.$store.state.CONFIG.site.anonymous.status || false
      },
      title () {
        switch (this.step) {
          case 1:
            return '编辑问题'
          case 2:
            return '编辑问题'
          default:
            return '发布问题'
        }
      },
      disabled () {
        let result
        switch (this.step) {
          case 1:
            result = !this.question.title || !this.question.body
            break
          case 2:
            result = true
            break
        }
        return result
      },
      questionId () {
        return Number(this.$route.params.questionId)
      },
    },
    watch: {
      step (val) {
        val === 2 &&
          this.$nextTick(() => {
            if (this.$refs.editor) {
              this.$refs.editor.innerHTML = this.question.body
            }
          })
        val === 3 && this.getTopics()
      },
      compose (val) {
        this.question.title = val
      },
    },
    mounted () {
      this.fetchQuestion()
    },
    activated () {
      this.$refs.title && this.$refs.title.focus()
    },
    methods: {
      fetchQuestion () {
        this.loading = true
        api.show(this.questionId)
          .then(({ data }) => {
            this.loading = false
            const { subject, text_body: text, anonymity, attachments, image, topics, tags } = data

            this.tags = tags
            this.topic = topics.pop()
            this.attachments = attachments
            this.question = { title: subject, body: text, anonymity }
            this.images = image.map(img => {
              return {
                'loading': false,
                'error': false,
                'file': null,
                'height': 0,
                'width': 0,
                'id': img,
                'name': 'image',
                'src': `${process.env.VUE_APP_API_HOST}/api/v2/files/${img}?q=30`,
              }
            })
          })
      },
      async getTopics () {
        const { data } = await api.getTopics()
        this.topics = data || []
      },
      getAvatar (avatar) {
        avatar = avatar || {}
        return avatar.url || null
      },
      preStep () {
        if (this.step <= 1) return
        this.animated = {
          enterClass: 'animated slideInLeft',
          leaveClass: 'animated slideOutRight',
        }
        this.step -= 1
      },
      nextStep () {
        if (this.disabled) return
        if (this.step < 4) {
          this.animated = {
            enterClass: 'animated slideInRight',
            leaveClass: 'animated slideOutLeft',
          }
          var endsWithQuesionMark =
            this.question.title.endsWith('?') ||
            this.question.title.endsWith('？')
          if (this.step === 1 && endsWithQuesionMark) {
            this.question.title += '?'
          }
          this.step += 1
        }
      },
      beforePost () {
        const { question, attachments = [] } = this
        let { body, title, anonymity } = question
        if (!body) {
          return (this.step = 2) && this.$Message.error('请输入问题详情')
        }

        if (!title) {
          return (this.step = 1) && this.$Message.error('请输入问题标题')
        }

        if (this.tags.length === 0) {
          return (this.step = 2) && this.$Message.error('请选择标签')
        }
        if (!this.topic || !this.topic.id) {
          return (this.step = 2) && this.$Message.error('请选择栏目')
        }

        // 检测标题尾部问号
        let hasQuestionMark = title.charAt(title.length - 1).match(/[?？]$/)

        let newBody = body
        this.images.forEach(element => {
          newBody += `<img src="/api/v2/files/${element.id}">`
        })

        this.editQuestion({
          subject: title + (hasQuestionMark ? '' : '?'),
          topics: [{ id: this.topic.id }],
          tags: this.tags,
          body: newBody,
          text_body: body,
          anonymity,
          attachments: attachments.map(item => item.id),
        })
      },
      editQuestion (params) {
        if (this.loading) return
        this.loading = true
        api.editQuestion(this.questionId, params)
          .then(({ data: { message, question } }) => {
            this.$Message.success(this.$t('release.success'))
            this.$router.replace(`/questions/${this.questionId}`)
          })
          .finally(() => {
            this.loading = false
          })
      },
      cancel () {
        const quit = () => {
          this.goBack()
          this.$destroy()
        }
        const saveDraft = () => {
          this.$lstore.setData('H5_POST_QUESTION_DRAFT', this.question)
          quit()
        }

        if (!this.question.title && !this.question.body) return quit()
        const actions = [
          { style: { color: '#f4504d' }, text: '放弃', method: quit },
          { text: '保存草稿', method: saveDraft },
        ]
        this.$bus.$emit(
          'actionSheet',
          actions,
          '取消',
          '你还有未发布的内容，是否放弃发布？'
        )
      },
      selectTopic () {
        this.$refs.chooseTopics.show()
      },
      onTopicChange (topic) {
        this.topic = { id: topic.id, name: topic.name }
      },
      uploadAttachments () {
        if (!this.inputShow) {
          return this.$Message.error('上传中...')
        }
        this.$refs.imagefile.click()
      },
      async onBannerChange () {
        const $input = this.$refs.imagefile
        const file = $input.files[0]
        // 上传图片
        this.inputShow = false
        let id
        try {
          id = await sendImage(file)
        } catch (e) {}
        this.inputShow = true
        this.attachments.push({ id, file })
      },
      deleteAttachments ({ id }) {
        this.attachments = this.attachments.filter(item => item.id !== id)
      },
    },
  }
</script>

<style lang="less" scoped>
.p-post-question {
  min-height: 100vh;
  background-color: #fff;
}
.p-post-question-main {
  display: flex;
  flex-direction: column;
  min-height: 90vh;
  > div {
    animation-duration: 0.3s;
  }

  .m-pos-f {
    // top: 90px;
    position: relative;
    margin: 0;
  }

  .question-title {
    flex: none;
    padding: 25px 0;
    border-bottom: 1px solid @border-color; /* no */
    &.step3 {
      padding: 40px;
    }

    input {
      font-size: 30px;
      line-height: 1.5;
      width: 100%;
    }
  }

  .question-list {
    flex: auto;
    overflow: auto;

    li {
      border-bottom: 1px solid @border-color; /*no*/
      color: @text-color2;
      font-size: 30px;
      padding: 40px;
    }
  }

  .m-reles-body {
    height: auto;
    margin-bottom: 0;

    textarea {
      font-size: 0.32rem;
      line-height: 1.5;
      overflow: auto;
      margin-top: 0.35rem;
      padding: 0 0.3rem;
      background-color: transparent;
      outline: 0;
      border: 0;
      resize: none;
      width: 100%;
      max-height: 100%;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-appearance: none !important;
      -moz-appearance: none !important;
    }
  }

  .anonymity-switch {
    position: fixed;
    bottom: 0;
    width: 100%;
    border-top: 1px solid @border-color; /* no */
  }
}

.m-editor {
  border: 0;
  outline: 0;
  line-height: 1.5;
  word-wrap: break-word;
  overflow-x: hidden;
  overflow-y: auto;
  _overflow-y: visible;
  -webkit-user-modify: read-write-plaintext-only; // 只是编辑text文本，只能解决webkit内核里面问题，手机端适用
  user-select: text;
  -webkit-user-select: text; // 解决IOS部分手机不支持contenteditable=true属性问题
}

.m-topics {
  overflow-y: auto;

  &.ml {
    margin-left: 15px;
  }

  li.m-topic {
    float: left;
    margin-left: 15px;
    margin-top: 20px;
    padding: 0 20px;
    height: 50px;
    line-height: 50px;
    border-radius: 25px;
    background-color: rgba(89, 182, 215, 0.2);
    color: @text-color2;
    font-size: 26px;

    > .m-svg-def {
      margin-left: 20px;
      width: 32px;
      height: 32px;
      fill: #b2b2b2;
    }
  }
  div.m-topic {
    padding: 30px;
    .m-topic-avatar {
      width: 80px;
      height: 80px;
      background-color: #ccc;
      margin-right: 30px;
    }
    h3 {
      font-size: 30px;
      line-height: 1.5;
    }

    p {
      width: 100%;
      margin-top: 9px;
      overflow: hidden;
      font-size: 24px;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: @text-color3;
    }
  }
}
.content-wrap {
  position: relative;
  width: 100%;
  // height: calc(~"100% + 40px");
  padding-right: 20px;
  margin-top: 15px;
  // padding-left: 30px;

  .textarea-shadow {
    opacity: 0;
    min-height: 100px;
    padding: 28px 0;
    word-wrap: break-word;
    word-break: break-all;
  }

  textarea {
    top: 0;
    display: block;
    font-size: 30px;
    // padding: 28px 0;
    width: calc(~"100% - 20px");
    height: 100%;
    overflow: hidden;
    resize: none;
    outline: none;
    min-height: 50px;
    background-color: transparent;
    word-wrap: break-word;
    word-break: break-all;
  }
}
.upload-img {
  text-align: left;
  width: 100%;
  z-index: 100;
}
.uploader {
  border: 1px solid #dbdbdb;
  display: inline-block;
  height: 150px;
  width: 150px;
  padding-top: 50px;
  padding-left: 50px;
  margin: 0 auto;
}
.content-main {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: auto;
  flex-grow: 1;
  padding: 30px;
  background-color: white;
  // padding-bottom: 120px !important;
}
.form-select-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 30px;
  background-color: #fff;
  border-bottom: 1px solid @border-color; /* no */
  .input-wrap {
    svg {
      vertical-align: middle;
    }
  }

  .placeholder {
    margin-right: 20px;
    color: #999;
  }
  .required-dot {
    color: #d52b1e;
    display: inline-block;
  }
}
.second-content {
  background-color: #f4f5f5;
}
.m-post-news-row {
  font-size: 30px;
  padding: 29px 20px;
  margin-top: 20px;
  display: flex;
  align-items: center;

  .m-entry-append {
    margin-left: 10px;
  }
  &-label {
    flex: none;
    align-self: flex-start;
    width: 150px;
  }
  input {
    height: 100%;
    width: 100%;
    line-height: 30px;
    font-size: 28px;
  }

  .c-textarea-input {
    text-align: right;
  }
  .m-tag {
    height: 50px;
    background-color: #f4f4f4;
    border-radius: 25px;
  }
  .upload-button {
    height: 50px;
    color: #fff;
    font-size: 24px;
    background-color: #00aeef;
    border-radius: 25px;
    padding: 8px 30px;
  }
}

.m-box-with-wrap {
  flex-wrap: wrap;
}
.attachments_content {
  flex-basis: 100%;
  margin-top: 20px;
  .attachments_name {
    display: inline-block;
    font-size: 28px;
    margin-left: 10px;
    flex-grow: 1;
    word-break: break-all;
  }
  img {
    margin-left: 20px;
    width: 32px;
    height: 32px;
  }
}
.attachment-with-box {
  width: 100%;
}
.set-reward {
  padding: 20px;
  font-size: 28px;
  color: #999;
  background-color: #fff;

  .reward-items {
    display: flex;
    justify-content: space-between;

    > li {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      margin-top: 20px;
      width: 30%;
      height: 70px;
      border: 1px solid @border-color;
      border-radius: 8px;

      &.active {
        color: @primary;
        border-color: @primary;
      }
    }
  }
}
.submit {
  border-radius:10px;
  background-color: #00AEEF;
  padding: 22px 312px;
  font-size:32px;
  color: #fff;
  margin: 0 auto;
  margin-top: 50px;
}
.rule {
  display: flex;
  font-size: 28px;
  margin: 8px 0 16px;
  color: #999;
  font-size: 28px;
  align-items: center;
  margin: 38px 30px;
  .m-icon-svg {
    margin-right: 0.5em;
    color: #999;
  }
  .reward-rule {
    width: 30px;
    height: 30px;
    margin-right: 14px;
    display: inline-block;
  }
}
</style>

<style scoped>
.select-tags >>> .input-wrap {
  width:auto
}
.form-member {
  padding-left: 30px;
  margin: 20px 0;
}
</style>
